var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 3.3275C2.5 2.87083 2.87083 2.5 3.3275 2.5H16.6725C17.1292 2.5 17.5 2.87083 17.5 3.3275V16.6725C17.4998 16.8919 17.4125 17.1022 17.2574 17.2574C17.1022 17.4125 16.8919 17.4998 16.6725 17.5H3.3275C3.1081 17.4998 2.89775 17.4125 2.74261 17.2574C2.58747 17.1022 2.50022 16.8919 2.5 16.6725V3.3275ZM4.16667 4.16667V15.8333H15.8333V4.16667H4.16667ZM8.85167 7.0125L12.9175 9.7225C12.9632 9.75293 13.0007 9.79418 13.0267 9.84259C13.0526 9.89101 13.0662 9.94508 13.0662 10C13.0662 10.0549 13.0526 10.109 13.0267 10.1574C13.0007 10.2058 12.9632 10.2471 12.9175 10.2775L8.85083 12.9875C8.80069 13.0207 8.74249 13.0398 8.68239 13.0426C8.6223 13.0455 8.56256 13.032 8.50951 13.0036C8.45645 12.9753 8.41207 12.9331 8.38105 12.8815C8.35003 12.83 8.33354 12.771 8.33333 12.7108V7.28917C8.33344 7.22888 8.34991 7.16974 8.38097 7.11807C8.41202 7.06639 8.45652 7.02411 8.50971 6.99572C8.56289 6.96733 8.62279 6.9539 8.683 6.95685C8.74322 6.95981 8.80151 6.97904 8.85167 7.0125Z",
    fill: "#0C4ACF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.da12f84967f969ee5ef4a68025ae9ec6.svg";
export { ForwardRef as ReactComponent };